import { css } from '@emotion/css';

const wrapper = css`
  &.MuiPaper-root {
    margin: 0 var(--spacings-4);
    position: relative;
    background-color: var(--colors-primary-100);
    border: 1px solid var(--colors-primary-300);
    max-width: 350px;
    display: inline-grid;
    grid-template-columns: 1fr 3fr;
    grid-auto-rows: auto;
    gap: var(--spacings-2);
    padding: var(--spacings-2);
    border-radius: var(--radius-3);
    align-items: center;
    justify-items: center;
    justify-self: stretch;
  }
`;

const imageContainer = css`
  grid-column: 1 / 2;
  grid-row: 1;
`;

const textContainer = css`
  grid-column: 2 / 3;
  grid-row: 1;
`;

const selectorContainer = css`
  display: flex;
  z-index: 1;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  position: absolute;
  right: var(--spacings-2);
  bottom: var(--spacings-2);
`;

const dotSelector = css`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
`;

const activeDot = css`
  background-color: var(--colors-primary-900);
`;

const inactiveDot = css`
  background-color: var(--colors-primary-300);
`;

const ServiceBoxStyles = {
  wrapper,
  imageContainer,
  textContainer,
  selectorContainer,
  dotSelector,
  activeDot,
  inactiveDot,
};

export default ServiceBoxStyles;
